module.exports = __webpack_public_path__ + "static/media/message-promotion-season@2x.ee6a8065.png";